import { API } from '@/src/api/api'
import { queryKeys } from '@/src/api/queryKeys'
import type { AllAdjustmentsResponseDTO, LoadPlanningWithStrategyDTO } from '@api/types/procurement'
import { useQuery } from '@tanstack/react-query'
import { mapToEnergyTypeDto } from '../details/types/adjustment.utils'
import type { ProcurementEnergyType } from '../load-planning/LoadPlanning.types'

export const useAdjustmentsByMeasure = (measureId?: string) => {
  return useQuery<AllAdjustmentsResponseDTO, Error>({
    queryKey: queryKeys.procurement.measureSimulation.fetchByMeasureId.toKeyWithArgs(measureId),
    enabled: !!measureId,
    queryFn: async () => {
      return API.procurements.fetchAdjustmentsByMeasureSimulation({ measureId })
    },
  })
}

export const useLoadPlannings = (companyId?: number) => {
  return useQuery<LoadPlanningWithStrategyDTO[], Error>({
    queryKey: queryKeys.procurement.loadPlanningsV2.fetchAll.toKeyWithArgs(companyId),
    enabled: !!companyId,
    queryFn: async () => {
      if (!companyId) return []
      return API.procurements.fetchAllLoadPlannings({ companyId })
    },
  })
}

export const useLoadPlanning = (companyId?: number, year?: number, energyType?: string) => {
  return useQuery<LoadPlanningWithStrategyDTO | undefined, Error>({
    queryKey: queryKeys.procurement.loadPlanningsV2.fetchOne.toKeyWithArgs(companyId, year, energyType),
    enabled: !!companyId && !!year && !!energyType,
    queryFn: async () => {
      if (!companyId) return undefined
      const loadPlannings = await API.procurements.fetchAllLoadPlannings({
        companyId,
        year,
        energyType: mapToEnergyTypeDto(energyType as ProcurementEnergyType),
      })
      return loadPlannings?.length > 0 ? loadPlannings[0] : undefined
    },
  })
}
